<template>
  <v-container id="selectorlocalidad-caplp">
    <v-row>
      <v-col cols="7" md="8" lg="8">
        <v-text-field
          v-model="nombre"
          :label="Localidad"
          v-on:keyup.enter="BuscarRegistro"
          v-on:blur="BuscarRegistro"
          height="20px"
        />
      </v-col>
      <v-col cols="4" md="3" lg="3">
        <v-btn
          class="ma-2"
          fab
          dark
          x-small
          color="primary"
          title="Buscar"
          @click="BuscarRegistro"
        >
          <v-icon dark> mdi-magnify </v-icon>
        </v-btn>
        <v-btn
          class="ma-2"
          fab
          dark
          x-small
          color="primary"
          title="Quitar Filtro"
          @click="QuitarRegistro"
        >
          <v-icon dark> mdi-cancel </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="dialogmensaje" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ mensajetitulo }}
        </v-card-title>
        <v-card-text>
          {{ mensajecuerpo }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" text @click="dialogmensaje = false">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="loading" full-width>
      <v-container
        fluid
        class="full-height"
        style="background-color: rgba(255, 255, 255, 0.5)"
      >
        <v-row
          align="center"
          justify="center"
          style="height: 100vh"
          no-gutters
          dense
        >
          <v-col class="elementocentrado">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
    <v-dialog v-model="dialogbusqueda" persistent max-width="1024">
      <v-card>
        <v-card-title class="headline"> Seleccione Localidad </v-card-title>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="dialogbusqueda = false">
            Cerrar
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <v-card>
            <v-card-title>
              Localidades
              <v-spacer></v-spacer>
              <v-select
                v-model="filtroprov"
                :items="listaprovincias"
                label="Provincia"
                item-text="nombre"
                item-value="idprovincia"
                height="20px"
                v-on:change="BuscarRegistro()"
              />
              <v-spacer></v-spacer>
              <v-text-field
                v-model="buscador"
                append-icon="mdi-magnify"
                label="Search"
                height="20px"
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="columnasgrilla"
              :items="listagrilla"
              :search="buscador"
              :items-per-page="10"
              :footer-props="{
                'items-per-page-text': 'Filas por Página:',
                'items-per-page-all-text': 'Todos',
              }"
              class="elevation-1"
              dense
              no-data-text="Sin Registros"
              multi-sort
            >
              <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="seleccionar(item)">
                  mdi-arrow-right
                </v-icon>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from "@/axios";
export default {
  data() {
    return {
      loading: false,
      dialogmensaje: false,
      mensajetitulo: '',
      mensajecuerpo: '',
      id: 0,
      nombre: '',
      listagrilla: [],
      dialogbusqueda: false,
      columnasgrilla: [
        {
          text: "Op.",
          value: "actions",
          sortable: false,
          width: 15,
        },
        {
          text: "ID",
          align: "center",
          sortable: true,
          value: "idlocalidad",
          width: 20,
        },
        {
          text: "Nombre",
          align: "center",
          sortable: true,
          value: "nombre",
          width: 250,
        },
        {
          text: "Provincia",
          align: "center",
          sortable: true,
          value: "provincia",
          width: 100,
        },
        {
          text: "Depto",
          align: "center",
          sortable: true,
          value: "departamento",
          width: 100,
        }
      ],
      Localidad: 'Localidad',
      buscador: '',
      listaprovincias: [],
      filtroprov: 42
    };
  },
  props: ["idinicial", "titulo"],
  mounted() {
    this.loading = true;
    this.id = '';
    this.nombre = '';
    if (this.titulo != null && this.titulo.length > 0) {
      this.Localidad = this.titulo;
    }
    axios.get("referenciales/provincia")
    .then((result) => {
      if(result.data.resultado===0){
        this.listaprovincias = result.data.datos;
        this.listaprovincias.unshift({idprovincia: 0, nombre: '(TODAS)'});
        if (this.idinicial != null && this.idinicial != '' && this.idinicial > 0) {
            this.BuscarRegistro();
        }else{
            this.loading = false;
        }
      }else{
        this.loading = false;
        this.MostrarMensaje("Error", result.data.resultadomensaje);
      }
    })
    .catch((error) => {
      this.loading = false;
      this.MostrarMensaje("Error", error);
    });
  },
  watch: {
    idinicial: function (val) {
      if (val != null && val != "") {
        this.id = val;
        this.nombre = "";
        this.BuscarRegistro();
      }
    },
  },
  methods: {
    MostrarMensaje(titulo, cuerpo) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.dialogmensaje = true;
    },
    BuscarRegistro() {
      this.loading = true;
      var id = this.idinicial != null && this.idinicial != "" && this.idinicial > 0 ? this.idinicial : this.id != "" && this.id != null ? this.id : 0;
      var nom = this.nombre != "" && this.nombre != null ? this.nombre : " ";
      var prov= this.filtroprov!=null && this.filtroprov!='' ? this.filtroprov : 0;
      var parametro= {id: id, idprovincia: prov, nombre: nom};
      axios.post("referenciales/PostLocalidades", parametro, {
        headers: {
            "Content-Type": "application/json",
        },
      })
       .then((result) => {
          if(result.data.resultado===0){
            this.listagrilla = result.data.datos;
            this.loading = false;
            if (this.listagrilla.length === 0) {
                this.MostrarMensaje("Atención", "No existen registros con los criterios seleccionados!!!");
            } else if (this.listagrilla.length === 1) {
                this.id = this.listagrilla[0].idlocalidad;
                this.nombre = this.listagrilla[0].nombre;
                this.$emit("selLocalidad", this.listagrilla[0]);
            } else {
                this.dialogbusqueda = true;
            }
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error);
        });
    },
    QuitarRegistro() {
      this.id = "";
      this.nombre = "";
      this.listagrilla = [];
      this.$emit("selLocalidad", null);
    },
    seleccionar(item) {
      this.loading = true;
      this.id = item.idlocalidad;
      this.nombre = item.nombre;
      this.$emit("selLocalidad", item);
      this.dialogbusqueda = false;
      this.loading = false;
    },
  },
};
</script>
<style>
</style>